import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { isActiveFee, Fee$reflection } from "../FeesTable/Model.js";
import { record_type, bool_type, option_type, int32_type, lambda_type, unit_type, string_type, list_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { LoadState_zip4, LoadState_zip3, loadEffect, SaveStatus, LoadState$2, getTranslationFrom, GlobalDependencies$reflection, LoadState$2$reflection } from "../../Global.js";
import { PaymentMethod$reflection } from "../../DomainTypes.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useSelector } from "../../Redux/Store.js";
import * as react from "react";
import { getCreateFeeDTOV2 } from "../FeeModal/Model.js";
import { startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { singleton } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { saveAnnulFee as saveAnnulFee_1, createFeeV2 } from "../../Api/Fee.js";
import { terminateFee as terminateFee_1, updateFee as updateFee_1, reactivateFee, loadMaxFee as loadMaxFee_1, loadChartOfAccounts as loadChartOfAccounts_1, loadFeeTemplates as loadFeeTemplates_1 } from "./Api.js";
import { dotsLoading } from "../../ViewUtils.js";
import { error } from "../../Components/Message/Message.js";
import { FeesTableProps, view, CreateFeeProps, renderCreateFeeButton } from "../FeesTable/View.js";
import { stackClasses, Locale_get_FromSelectedLanguage } from "../../Utils.js";
import { FeeConfig } from "../../GlobalTypes.js";
import { FeeType, FeeVersion } from "../FeeModal/View.js";
import { singleton as singleton_2, ofArray, isEmpty, filter, sortByDescending } from "../../fable_modules/fable-library.3.7.20/List.js";
import { uncurry, equals, compareArrays, compare, max } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { InactiveFeesTableProps, renderInactiveFeesTable } from "../FeesTable/InactiveFees.js";
import { HTMLAttr } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { CollapseProps, collapse } from "../../Components/Collapse/Collapse.js";
import { keyValueList } from "../../fable_modules/fable-library.3.7.20/MapUtil.js";
import { convertFeeToTerminateFeeDTO, getUpdateFeeDTOs } from "../CustomerFees/Model.js";
import { saveMaxBilledToNextTime as saveMaxBilledToNextTime_1, saveEarliestInvoiceDate as saveEarliestInvoiceDate_1, saveBilledTo as saveBilledTo_1 } from "../FeesTable/Api.js";
import { empty, singleton as singleton_1, append, delay, toList } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { render as render_1 } from "../../Components/Modals/SaveState/SaveState.js";
import { ModalSize } from "../../Components/Modal/Modal.js";
import { ConsumptionFeesTableProps, CopyToFeeProps, renderConsumptionFees } from "../ConsumptionFees/View.js";
import "../../../src/Containers/ContractFees/View.scss";


export class FeesProps extends Record {
    constructor(Fees, ReloadFeesFn, GlobalDependencies, ContractNr, ContractTypeCode, ProductNr, PaymentMethod, ShouldRenderInactiveFees, BillingInterval, ShouldRenderCreateFeeButton, ReloadInvoiceeCurrentStateFn) {
        super();
        this.Fees = Fees;
        this.ReloadFeesFn = ReloadFeesFn;
        this.GlobalDependencies = GlobalDependencies;
        this.ContractNr = (ContractNr | 0);
        this.ContractTypeCode = ContractTypeCode;
        this.ProductNr = ProductNr;
        this.PaymentMethod = PaymentMethod;
        this.ShouldRenderInactiveFees = ShouldRenderInactiveFees;
        this.BillingInterval = (BillingInterval | 0);
        this.ShouldRenderCreateFeeButton = ShouldRenderCreateFeeButton;
        this.ReloadInvoiceeCurrentStateFn = ReloadInvoiceeCurrentStateFn;
    }
}

export function FeesProps$reflection() {
    return record_type("Containers.ContractFees.View.FeesProps", [], FeesProps, () => [["Fees", LoadState$2$reflection(list_type(Fee$reflection()), string_type)], ["ReloadFeesFn", lambda_type(unit_type, unit_type)], ["GlobalDependencies", GlobalDependencies$reflection()], ["ContractNr", int32_type], ["ContractTypeCode", string_type], ["ProductNr", option_type(int32_type)], ["PaymentMethod", PaymentMethod$reflection()], ["ShouldRenderInactiveFees", bool_type], ["BillingInterval", int32_type], ["ShouldRenderCreateFeeButton", bool_type], ["ReloadInvoiceeCurrentStateFn", lambda_type(unit_type, unit_type)]]);
}

export const renderFeesSection = FunctionComponent_Of_Z5A158BBF((props) => {
    let inputRecord_1, inputRecord;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const feeTemplatesState = react.useState(new LoadState$2(0));
    const chartOfAccountsState = react.useState(new LoadState$2(0));
    const maxFeeState = react.useState(new LoadState$2(0));
    const errorMessageState = react.useState(void 0);
    const terminateFeeSaveState = react.useState(new SaveStatus(0));
    const createFee = (vm) => {
        const dto = getCreateFeeDTOV2(void 0, props.ContractNr, vm);
        startImmediate(singleton.Delay(() => singleton.Bind(createFeeV2(props.GlobalDependencies.ClientNr, dto), (_arg) => {
            const result = _arg;
            if (result.tag === 1) {
                errorMessageState[1](result.fields[0]);
                return singleton.Zero();
            }
            else {
                props.ReloadInvoiceeCurrentStateFn();
                props.ReloadFeesFn();
                return singleton.Zero();
            }
        })));
    };
    react.useEffect(() => {
        loadEffect(() => loadFeeTemplates_1(props.GlobalDependencies.ClientNr), (arg) => {
            feeTemplatesState[1](arg);
        });
        loadEffect(() => loadChartOfAccounts_1(props.GlobalDependencies.ClientNr), (arg_1) => {
            chartOfAccountsState[1](arg_1);
        });
        loadEffect(() => loadMaxFee_1(props.GlobalDependencies.ClientNr, props.ContractNr), (arg_2) => {
            maxFeeState[1](arg_2);
        });
    }, [props.GlobalDependencies]);
    const matchValue_1 = LoadState_zip3(feeTemplatesState[0], chartOfAccountsState[0], maxFeeState[0]);
    switch (matchValue_1.tag) {
        case 1: {
            return dotsLoading;
        }
        case 3: {
            return error(matchValue_1.fields[0].split(""));
        }
        case 2: {
            const maxFeeDTO = matchValue_1.fields[0][2];
            const createFeeButtonHtml = props.ShouldRenderCreateFeeButton ? renderCreateFeeButton(new CreateFeeProps(matchValue_1.fields[0][0], matchValue_1.fields[0][1], props.GlobalDependencies.ClientConfig.UseAccountNo, props.BillingInterval, props.ContractTypeCode, props.ProductNr, Locale_get_FromSelectedLanguage()(props.GlobalDependencies.SelectedLanguage), props.GlobalDependencies.CountryCode, props.PaymentMethod, maxFeeDTO.FeeMax, createFee, props.GlobalDependencies.ClientConfig.EnableFeesV2 ? (new FeeVersion(1, (inputRecord_1 = props.GlobalDependencies.ClientConfig.FeeConfig, new FeeConfig(inputRecord_1.OneTime, inputRecord_1.Monthly, inputRecord_1.MonthlyDate, inputRecord_1.MonthlyWith3MonthsInvoice, inputRecord_1.MonthlyWith6MonthsInvoice, inputRecord_1.MonthlyWith12MonthsInvoice, inputRecord_1.QuarterlyDate, inputRecord_1.HalfYearDate, inputRecord_1.YearlyDate, false, inputRecord_1.DefaultMonthsInAdvance, inputRecord_1.DefaultCancellationPeriodMonths, inputRecord_1.UsesUnitPrice)))) : (new FeeVersion(0, (inputRecord = props.GlobalDependencies.ClientConfig.FeeConfig, new FeeConfig(inputRecord.OneTime, inputRecord.Monthly, inputRecord.MonthlyDate, inputRecord.MonthlyWith3MonthsInvoice, inputRecord.MonthlyWith6MonthsInvoice, inputRecord.MonthlyWith12MonthsInvoice, inputRecord.QuarterlyDate, inputRecord.HalfYearDate, inputRecord.YearlyDate, false, inputRecord.DefaultMonthsInAdvance, inputRecord.DefaultCancellationPeriodMonths, inputRecord.UsesUnitPrice)))), new FeeType(0), props.GlobalDependencies.ClientConfig.FeeConfig.UsesUnitPrice)) : react.createElement(react.Fragment, {});
            let feesHtml;
            let inactiveFeesHtml;
            const matchValue_4 = [props.ShouldRenderInactiveFees, props.Fees, feeTemplatesState[0]];
            let pattern_matching_result, feeTemplates_1, fees;
            if (matchValue_4[0]) {
                if (matchValue_4[1].tag === 2) {
                    if (matchValue_4[2].tag === 2) {
                        pattern_matching_result = 0;
                        feeTemplates_1 = matchValue_4[2].fields[0];
                        fees = matchValue_4[1].fields[0];
                    }
                    else {
                        pattern_matching_result = 1;
                    }
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else {
                pattern_matching_result = 1;
            }
            switch (pattern_matching_result) {
                case 0: {
                    const inactiveFees = sortByDescending((x_2) => [max(compare, x_2.EndDate, x_2.StartDate), x_2.CreatedTime], filter((arg_13) => (!isActiveFee(arg_13)), fees), {
                        Compare: compareArrays,
                    });
                    const locale = Locale_get_FromSelectedLanguage()(props.GlobalDependencies.SelectedLanguage);
                    if (isEmpty(inactiveFees)) {
                        inactiveFeesHtml = react.createElement(react.Fragment, {});
                    }
                    else {
                        const tableHtml = renderInactiveFeesTable(new InactiveFeesTableProps(inactiveFees, feeTemplates_1, locale, (feeNr) => {
                            startImmediate(singleton.Delay(() => singleton.Bind(reactivateFee(props.GlobalDependencies.ClientNr, feeNr), (_arg_1) => {
                                const result_1 = _arg_1;
                                if (result_1.tag === 1) {
                                    errorMessageState[1](result_1.fields[0]);
                                    return singleton.Zero();
                                }
                                else {
                                    props.ReloadInvoiceeCurrentStateFn();
                                    props.ReloadFeesFn();
                                    return singleton.Zero();
                                }
                            })));
                        }, props.GlobalDependencies.ClientConfig.FeeConfig.UsesUnitPrice, props.GlobalDependencies.ClientNr));
                        let headingHtml;
                        const children_3 = [getTranslation("CustomerContract.Invoicee.Subscriptions.Fees.TerminatedFees")];
                        headingHtml = react.createElement("h5", {
                            ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.Fees.TerminatedFees",
                        }, ...children_3);
                        const props_6 = [new HTMLAttr(65, stackClasses(ofArray(["mb-4", "mt-3"])))];
                        const children_5 = [collapse(new CollapseProps(tableHtml, headingHtml, false))];
                        inactiveFeesHtml = react.createElement("div", keyValueList(props_6, 1), ...children_5);
                    }
                    break;
                }
                case 1: {
                    inactiveFeesHtml = react.createElement(react.Fragment, {});
                    break;
                }
            }
            let activeFeesHtml;
            const matchValue_6 = LoadState_zip4(props.Fees, feeTemplatesState[0], chartOfAccountsState[0], maxFeeState[0]);
            switch (matchValue_6.tag) {
                case 1: {
                    activeFeesHtml = dotsLoading;
                    break;
                }
                case 3: {
                    activeFeesHtml = error(matchValue_6.fields[0].split(""));
                    break;
                }
                case 2: {
                    activeFeesHtml = view(new FeesTableProps(filter(isActiveFee, matchValue_6.fields[0][0]), matchValue_6.fields[0][1], props.GlobalDependencies, props.ProductNr, props.ContractTypeCode, matchValue_6.fields[0][2], props.PaymentMethod, props.BillingInterval, matchValue_6.fields[0][3].FeeMax, (tupledArg) => {
                        let matchValue, feeDTO;
                        const fee = tupledArg[0];
                        const vm_1 = tupledArg[1];
                        startImmediate((matchValue = [fee.BilledTo, vm_1.BilledTo, props.GlobalDependencies.IsAdminUser], (matchValue[0] != null) ? ((matchValue[1] == null) ? (matchValue[2] ? ((feeDTO = getUpdateFeeDTOs(fee, vm_1), singleton.Delay(() => singleton.Bind(updateFee_1(props.GlobalDependencies.ClientNr, props.ContractNr, feeDTO), (_arg_2) => {
                            const result_2 = _arg_2;
                            if (result_2.tag === 1) {
                                errorMessageState[1](result_2.fields[0]);
                                return singleton.Zero();
                            }
                            else {
                                props.ReloadInvoiceeCurrentStateFn();
                                props.ReloadFeesFn();
                                return singleton.Zero();
                            }
                        })))) : ((errorMessageState[1]("Cannot remove BilledTo, requires Admin privileges."), singleton.Return()))) : ((feeDTO = getUpdateFeeDTOs(fee, vm_1), singleton.Delay(() => singleton.Bind(updateFee_1(props.GlobalDependencies.ClientNr, props.ContractNr, feeDTO), (_arg_2) => {
                            const result_2 = _arg_2;
                            if (result_2.tag === 1) {
                                errorMessageState[1](result_2.fields[0]);
                                return singleton.Zero();
                            }
                            else {
                                props.ReloadInvoiceeCurrentStateFn();
                                props.ReloadFeesFn();
                                return singleton.Zero();
                            }
                        }))))) : ((feeDTO = getUpdateFeeDTOs(fee, vm_1), singleton.Delay(() => singleton.Bind(updateFee_1(props.GlobalDependencies.ClientNr, props.ContractNr, feeDTO), (_arg_2) => {
                            const result_2 = _arg_2;
                            if (result_2.tag === 1) {
                                errorMessageState[1](result_2.fields[0]);
                                return singleton.Zero();
                            }
                            else {
                                props.ReloadInvoiceeCurrentStateFn();
                                props.ReloadFeesFn();
                                return singleton.Zero();
                            }
                        }))))));
                    }, (tupledArg_1) => {
                        terminateFeeSaveState[1](new SaveStatus(1));
                        const terminateFeeDTO = convertFeeToTerminateFeeDTO(tupledArg_1[1]);
                        startImmediate(singleton.Delay(() => singleton.Bind(terminateFee_1(props.GlobalDependencies.ClientNr, props.ContractNr, tupledArg_1[0].FeeNumber, terminateFeeDTO), (_arg_3) => {
                            const result_3 = _arg_3;
                            if (result_3.tag === 1) {
                                errorMessageState[1](result_3.fields[0]);
                                return singleton.Zero();
                            }
                            else {
                                terminateFeeSaveState[1](new SaveStatus(2));
                                return singleton.Zero();
                            }
                        })));
                    }, (fee_2) => {
                        startImmediate(singleton.Delay(() => singleton.Bind(saveAnnulFee_1(props.GlobalDependencies.ClientNr, fee_2.FeeNumber), (_arg_4) => {
                            const result_4 = _arg_4;
                            if (result_4.tag === 1) {
                                errorMessageState[1](result_4.fields[0]);
                                return singleton.Zero();
                            }
                            else {
                                props.ReloadInvoiceeCurrentStateFn();
                                props.ReloadFeesFn();
                                return singleton.Zero();
                            }
                        })));
                    }, (feeNr_1, newBilledToDate) => {
                        startImmediate(singleton.Delay(() => singleton.Bind(saveBilledTo_1(props.GlobalDependencies.ClientNr, feeNr_1, newBilledToDate), (_arg_5) => {
                            const result_5 = _arg_5;
                            if (result_5.tag === 1) {
                                errorMessageState[1](result_5.fields[0]);
                                return singleton.Zero();
                            }
                            else {
                                props.ReloadInvoiceeCurrentStateFn();
                                props.ReloadFeesFn();
                                return singleton.Zero();
                            }
                        })));
                    }, (feeNr_2, date) => {
                        startImmediate(singleton.Delay(() => singleton.Bind(saveEarliestInvoiceDate_1(props.GlobalDependencies.ClientNr, feeNr_2, date), (_arg_6) => {
                            const result_6 = _arg_6;
                            if (result_6.tag === 1) {
                                errorMessageState[1](result_6.fields[0]);
                                return singleton.Zero();
                            }
                            else {
                                props.ReloadFeesFn();
                                return singleton.Zero();
                            }
                        })));
                    }, (feeNr_3, date_1) => {
                        startImmediate(singleton.Delay(() => singleton.Bind(saveMaxBilledToNextTime_1(props.GlobalDependencies.ClientNr, feeNr_3, date_1), (_arg_7) => {
                            const result_7 = _arg_7;
                            if (result_7.tag === 1) {
                                errorMessageState[1](result_7.fields[0]);
                                return singleton.Zero();
                            }
                            else {
                                props.ReloadFeesFn();
                                return singleton.Zero();
                            }
                        })));
                    }, new FeeType(2)));
                    break;
                }
                default: {
                    activeFeesHtml = react.createElement(react.Fragment, {});
                }
            }
            const children_9 = toList(delay(() => append(singleton_1(createFeeButtonHtml), delay(() => append(singleton_1(activeFeesHtml), delay(() => (props.ShouldRenderInactiveFees ? singleton_1(inactiveFeesHtml) : empty())))))));
            feesHtml = react.createElement("div", {
                className: "fees-container__fees",
            }, ...children_9);
            const terminateFeeSaveStatusModalHtml = render_1(!equals(terminateFeeSaveState[0], new SaveStatus(0)), new ModalSize(1), "", singleton_2([getTranslation("CustomerContract.Invoicee.Subscriptions.Fees.TerminatingFee"), terminateFeeSaveState[0]]), getTranslation("Common.Ok"), (_arg_8) => {
                props.ReloadInvoiceeCurrentStateFn();
                props.ReloadFeesFn();
                terminateFeeSaveState[1](new SaveStatus(0));
            });
            const consumptionFeesHtml = props.GlobalDependencies.ClientConfig.UsesConsumptionFees ? renderConsumptionFees(new ConsumptionFeesTableProps(props.GlobalDependencies, props.ContractNr, props.ShouldRenderInactiveFees, new CopyToFeeProps(props.ContractTypeCode, props.ProductNr, Locale_get_FromSelectedLanguage()(props.GlobalDependencies.SelectedLanguage), props.GlobalDependencies.CountryCode, new FeeType(0), props.PaymentMethod, maxFeeDTO.FeeMax, createFee))) : react.createElement(react.Fragment, {});
            let errorMessageHtml;
            const matchValue_8 = errorMessageState[0];
            if (matchValue_8 != null) {
                const msg_10 = matchValue_8;
                const children_13 = [error(msg_10.split(""))];
                errorMessageHtml = react.createElement("div", {
                    className: "mb-3",
                    id: "fees-model-error",
                }, ...children_13);
            }
            else {
                errorMessageHtml = react.createElement(react.Fragment, {});
            }
            return react.createElement("div", {
                className: "fees-container",
            }, errorMessageHtml, feesHtml, terminateFeeSaveStatusModalHtml, consumptionFeesHtml);
        }
        default: {
            return react.createElement(react.Fragment, {});
        }
    }
}, "FeesSection", uncurry(2, void 0), void 0, "renderFeesSection", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\ContractFees\\View.fs", 342);

